// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"b65b8eb5","845":"6e2c4e6a"}[chunkId] + ".chunk.js";
};